module.exports = __webpack_public_path__ + "static/finance-students-learn-secrets-of-the-trade-29362f2fbcb2dd911c7a4b98e3ebe00c.jpg";